import React, { useState, useEffect } from "react";
import { JobService } from "../../../../../services/JobService";
import { toast } from "react-toastify";
import $ from "jquery";
import {
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { useParams } from "react-router-dom";
import { getEnumLists } from "../../../../../services/MetadataService";

const SoftSkills = (props) => {
  var { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);

  const [scategories, setSCategories] = useState([]);

  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [modalRight, setModalRight] = useState(false);

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [softSkillId, setSoftSkillId] = useState("");
  const [softSkillName, setSoftSkillName] = useState("");
  const [jobSkillLevels, setJobSkillLevels] = useState([]);

  const [sortOrder, setSortOrder] = useState("asc");
  const [jobStatus, setJobStatus] = useState("");

  useEffect(() => {
    getJobEnums();
    getTotalSoftSkillsList();
    if (id != 0) {
      getJobDetails(id);
      getReqSoftSkillsList();
    }
  }, []);
  const getJobDetails = (jobId) => {
    var jobDetails = props.jobDetails;
    if (jobDetails != null) {
      if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
        setJobStatus(jobDetails.jobStatus.key);
      }
    }
  };
  const getJobEnums = () => {
    getEnumLists().then((response) => {
      if (response !== null) {
        let jobSkillLevels = response.jobSkillLevels;
        if (jobSkillLevels != null) {
          const skillLevel = jobSkillLevels.reverse();
          setJobSkillLevels(skillLevel);
        }
      }
    });
  };

  const getTotalSoftSkillsList = () => {
    JobService.getSoftSkillsService(sortOrder).then((response) => {
      var skillDetails = response.data;
      if (skillDetails != null) {
        const skills = skillDetails.skills;
        if (skills.length > 0) {
          setCategories(skills);
          setFilteredCategories(skills);
          for (let i = 0; i < skills.length; i++) {
            skills[i].skillLevel = "";
            skills[i].isChecked = false;
          }
          setCategories(skills);
          setFilteredCategories(skills);
        } else {
          setCategories([]);
          setFilteredCategories([]);
        }
      }
    });
  };

  const getReqSoftSkillsList = () => {
    JobService.getReqSoftSkillService(id).then((response) => {
      var skillDetails = response.data;
      if (skillDetails != null) {
        response.data.skills.map((skill, index) => {
          response.data.skills[index].isChecked = true;
        });

        setSCategories(response.data.skills);
      }
    });
  };

  const handleCheck = (event, softSkills, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      filteredCategories[index].isChecked = true;
      updatedList.push(softSkills.skillId);

      selectedSoftSkills.push({
        skillType: "SOFT_SKILL",
        skillId: softSkills.skillId,
        skillLevel: $("#" + softSkills.skillId + "_skillLevel").val(),
        // rating: 1
      });
      selectedIds.push({
        skillId: softSkills.skillId,
      });
    } else {
      for (var i = 0; i < selectedSoftSkills.length; i++) {
        if (selectedSoftSkills[i].skillId === softSkills.skillId) {
          selectedIds.splice(i, 1);
          selectedSoftSkills.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] === softSkills.skillId) {
          updatedList.splice(i, 1);
          // selectedIds.splice(i, 1);
        }
      }
      filteredCategories[index].isChecked = false;
    }

    setSelectedSoftSkills(selectedSoftSkills);

    setSelectedSkills(updatedList);
    setSelectedIds(selectedIds);
    setFilteredCategories(filteredCategories);
  };

  const updatesoftskills = () => {
    const jobId = window.localStorage.getItem("requestId");

    if (jobId === "") {
      toast.error("Please fill basic info");
      return;
    }

    const softskillsData = [];
    selectedSoftSkills.map((softskill) => {
      softskillsData.push({
        skillId: softskill.skillId,
      });
    });

    const softSkillsSelectedList = [];
    for (let i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId != null) {
        softSkillsSelectedList.push(selectedSoftSkills[i]);
      } else if (selectedSoftSkills[i].skillId == null) {
      }
    }

    const softskillsobject = {
      skills: softSkillsSelectedList,
    };

    if (selectedSoftSkills.length > 0) {
      JobService.updateSoftSkillsService(softskillsobject).then((response) => {
        try {
          var requestId = response.data.id;
          toast.success("Soft skills added successfully");
          setSCategories([]);
          setModalRight(false);
          getReqSoftSkillsList();
        } catch (err) {}
      });
    } else {
      toast.error("Please select soft skill");
    }
  };

  function handleSoftSkillLevel(e, id, index) {
    const updatedList = [...selectedIds];

    let selectedSoftSkillsList = [...selectedSoftSkills];
    if (selectedSoftSkillsList.length > 0) {
      for (var i = 0; i < selectedSoftSkillsList.length; i++) {
        if (selectedSoftSkillsList[i].skillId === id) {
          selectedSoftSkillsList[i].skillLevel = e.target.value;
        }
      }
      setSelectedSoftSkills(selectedSoftSkillsList);
    } else {
    }

    const softSkills = [...filteredCategories];
    if (softSkills.length > 0) {
      for (let i = 0; i < softSkills.length; i++) {
        if (softSkills[i].skillId == id) {
          softSkills[i].skillLevel = e.target.value;
        }
      }
      setFilteredCategories(softSkills);
    } else {
      setFilteredCategories([]);
    }
    setSelectedIds(selectedIds);
  }

  const onAddSoftSkills = () => {
    setSelectedSoftSkills([]);
    setSelectedIds([]);
    setSelectedSkills([]);
    resetSoftSkills();
    setModalRight(true);
    setlanguageShow(true);
  };

  const resetSoftSkills = () => {
    let categoriesList = [...categories];
    if (categoriesList.length > 0) {
      for (let i = 0; i < categoriesList.length; i++) {
        categoriesList[i].skillLevel = "";
        categoriesList[i].isChecked = false;
      }
      updateSoftSkillDetails(categoriesList);
    }
  };

  const updateSoftSkillDetails = (softSkills) => {
    let selectedSkillsList = [];
    for (let i = 0; i < softSkills.length; i++) {
      softSkills[i].skillLevel = "";
      if (scategories.length > 0) {
        scategories.map((skill) => {
          if (softSkills[i].skillId == skill.skillId) {
            softSkills[i].isChecked = true;
            if (skill.skillLevel !== null) {
              softSkills[i].skillLevel = skill.skillLevel.key;
              selectedSkillsList.push({
                skillType: "SOFT_SKILL",
                skillId: skill.skillId,
                skillLevel: skill.skillLevel.key,
              });
            }
          }
        });
      }
    }
    setSelectedSoftSkills(selectedSkillsList);
    setFilteredCategories(softSkills);
  };

  const searchItems = (searchValue) => {
    if (searchValue !== "") {
      if (searchValue.length >= 3) {
        JobService.searchSoftSkill(searchValue).then((response) => {
          try {
            if (response.message != null) {
              if (response.data.error_message !== "") {
              }
            } else {
              var languageDetails = response.data;
              if (languageDetails != null) {
                setlanguageShow(true);
                if (languageDetails.skills.length > 0) {
                  for (let i = 0; i < languageDetails.skills.length; i++) {
                    languageDetails.skills[i].skillLevel = "";
                  }
                  updateSoftSkills(languageDetails.skills);
                } else {
                  setFilteredCategories([]);
                }
              }
            }
          } catch (err) {}
        });
      } else {
        updateSoftSkills(categories);
      }
    } else {
      updateSoftSkills(categories);
    }
  };

  const updateSoftSkills = (skills) => {
    if (skills.length > 0) {
      for (let i = 0; i < skills.length; i++) {
        var skillId = skills[i].skillId;
        if (selectedSoftSkills.length > 0) {
          for (let j = 0; j < selectedSoftSkills.length; j++) {
            var selectedSkillId = selectedSoftSkills[j].skillId;
            var selectedSkillLevel = selectedSoftSkills[j].skillLevel;
            if (skillId == selectedSkillId) {
              skills[i].skillLevel = selectedSkillLevel;
            }
          }
        }
      }
      setFilteredCategories(skills);
    } else {
      setFilteredCategories([]);
    }
  };

  const seeFullList = () => {
    setModalRight(true);
    setFilteredCategories(categories);
    setlanguageShow((prev) => !prev);
  };

  const handleDeleteSoftSkill = (deletedId, name) => {
    setSoftSkillId(deletedId);
    setSoftSkillName(name);
  };

  const removeSkillDetails = () => {
    JobService.removeSOftSkillsService(softSkillId,id).then((response) => {
      toast.success("Soft skill deleted successfully");
      getReqSoftSkillsList();
    });
  };

  const checkSkillStatus = (skillId) => {
    var isSkillSelected = false;
    if (selectedSoftSkills.length > 0) {
      for (let i = 0; i < selectedSoftSkills.length; i++) {
        if (selectedSoftSkills[i].skillId == skillId) {
          isSkillSelected = true;
        }
      }
    }
    return isSkillSelected;
  };

  return (
    <div>
      <div className="skill-header mt-1">
        <div>
          <div className="profile-card-title">
            <label>
              <strong>
                <h2>Soft Skills</h2>
              </strong>
            </label>
          </div>
        </div>
        <div>
          {jobStatus !== "CLOSED" && (
            <Button
              color="primary"
              size="sm"
              disabled={
                window.localStorage.getItem("view") === "view" ? true : false
              }
              outline
              onClick={onAddSoftSkills}
            >
              Add Soft Skills
            </Button>
          )}
        </div>
      </div>

      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
          className="language-model-width"
        >
          <ModalHeader className="mdl_header">
            <div>
              <strong>Select your soft skills</strong>
            </div>
          </ModalHeader>

          <ModalBody className="labelSize">
            <div className="col-lg-12">
              <Input
                id="search"
                type="text"
                icon="search"
                placeholder="Search for soft skills"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>

            {languageshow &&
              filteredCategories.length > 0 &&
              filteredCategories.map((skill, index) => {
                return (
                  <div className="col-12" key={index}>
                    <div className="row">
                      <div className="col-sm-6 mt-2">
                        <label>
                          <div className="terms">
                            <input
                              id="softSkill"
                              type="checkbox"
                              className="input_skill"
                              checked={checkSkillStatus(skill.skillId)}
                              onChange={(e) => handleCheck(e, skill, index)}
                            />
                            {skill.name}{" "}
                          </div>
                        </label>
                      </div>

                      {checkSkillStatus(skill.skillId, index) ? (
                          <div className="col-sm-6 mb-2" key={index}>
                            <Input
                              width="5"
                              type="select"
                              id={skill.skillId + "_skillLevel"}
                              value={skill.skillLevel}
                              onChange={(e) =>
                                handleSoftSkillLevel(e, skill.skillId, index)
                              }
                            >
                              {jobSkillLevels.map(({ value, key }) => (
                                <option value={key}>{value}</option>
                              ))}
                            </Input>
                          </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                );
              })}
            {filteredCategories.length == 0 && (
              <div className="t-nodata mt-4">
                <strong>Softskill not found</strong>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="p-4">
            <Button
              color="primary"
              size="sm"
              outline
              onClick={updatesoftskills}
            >
              Save
            </Button>{" "}
            <Button
              color="primary"
              size="sm"
              outline
              onClick={() => setModalRight(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      {scategories.length > 0 && (
        <Card className="mt-4">
          <CardBody>
            {scategories.map((skill,index) => {
              return (
                <div key={skill.skillId+index} className="col mt-1">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="tracbox">
                          <label>
                            <div className="terms">{skill.name}</div>
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="tracbox">
                          <label>
                            <div id="skillLevel" className="terms">
                              {skill.skillLevel.value}
                            </div>
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-2">
                        <Row>
                          <div>
                            {jobStatus !== "CLOSED" && (
                              <span className="notDisabled ml-2 t-cursor-pointer">
                                  <i
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#exampleModaltop"
                                    className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 mb-2 emp_icon"
                                    onClick={() =>
                                      handleDeleteSoftSkill(
                                        skill.id,
                                        skill.name
                                      )
                                    }
                                  />
                              </span>
                            )}
                            <div
                              className="modal fade mt-5"
                              id="exampleModaltop"
                              tabIndex="-1"
                              role="dialog"
                              aria-labelledby="exampleModalLabeltop"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                  <div className="modal-body">
                                    <h3>
                                      Do you want to delete{" "}
                                      <strong>
                                        {" " + softSkillName + " "}{" "}
                                      </strong>
                                      SoftSkill?
                                    </h3>
                                  </div>

                                  <div className="modal-footer p-3">
                                    <Button
                                      type="button"
                                      color="primary"
                                      size="sm"
                                      outline
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="button"
                                      color="primary"
                                      size="sm"
                                      outline
                                      data-dismiss="modal"
                                      onClick={() => {
                                        removeSkillDetails();
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default SoftSkills;
